import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { useHistory } from 'react-router';

import NumberInput from '~ComponentsImproved/Numpad';
import { useI18n } from '~Hooks';

const GetBackArea = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 50%;
  height: 300px;
`;

const pass = '1111';

const GetBack = () => {
  const { push } = useHistory();
  const [clickCount, setClickCount] = useState(0);
  const [accessCodeInput, setAccessCodeInput] = useState(false);
  const { i18n } = useI18n();

  useEffect(() => {
    if (clickCount === 5) {
      setAccessCodeInput(true);
      setClickCount(0);
    }

    // If the user does not have time to click on the specified area 5 times, the click counter is reset
    const timer = setTimeout(() => {
      setClickCount(0);
    }, 2000);

    return () => clearTimeout(timer);
  }, [clickCount]);

  function onSubmit(value: string) {
    if (value === pass) {
      setAccessCodeInput(false);
      setTimeout(() => {
        push('gateway');
      }, 500);
    }
  }

  return (
    <>
      <GetBackArea onTouchStart={() => setClickCount((state) => ++state)} />
      {accessCodeInput && (
        <NumberInput
          decimal
          title={i18n('SSK.EnterTheCode')}
          onClose={() => setAccessCodeInput(false)}
          onSubmit={onSubmit}
        />
      )}
    </>
  );
};

export default GetBack;
